// Function to add the "Add to Cart" button (with SVG) to each product item
function addWishlistButton() {


let lastUrl = window.location.href;

function checkUrlChange() {
  const currentUrl = window.location.href;

  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    addWishlistButton();
  }
}

// Set interval to check for URL change
setInterval(checkUrlChange, 500); // Adjust the interval as needed (e.g., 500ms)


document.addEventListener('keydown', function(event) {
  // Check if the key pressed is '+' (key code 187) or '-' (key code 189)
  console.log(event.key, 'what is this event');
  if (event.key === '+' || event.key === '-' || event.key === '=') {
    
    setTimeout(() => {
      addWishlistButton(); // Re-add the wishlist button after zoom
    }, 500); // Adjust delay as needed
  }
});




  
  // Add event listener to the wishlist button to open the modal
document.querySelector('.snize-pagination').addEventListener('click', function(event) {
  if (event.target.tagName.toLowerCase() === 'a') {
    const href = event.target.getAttribute('href');
    
    if (href && href.includes('collections/all')) {
      setTimeout(() => {
        addWishlistButton(); // Re-add the wishlist button after pagination
      }, 1000);
    }
  }
});

// Get the slider container element
const priceSlider = document.querySelector('.snize-price-range-slider');

  
  const existingWishlistBtn = document.querySelector('.footer-extra .snize-wishlist-button');
  const modaloverlay = document.querySelector('.modal-overlay');

if (!existingWishlistBtn) {
  const wishlistBtn = document.createElement('button');
  wishlistBtn.classList.add('snize-wishlist-button');
  wishlistBtn.innerHTML = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3c3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#333"/>
    </svg>
    Wishlist
  `;
  
  wishlistBtn.style.position = 'fixed';
  wishlistBtn.style.bottom = '50%';
  wishlistBtn.style.right = '2px';
  wishlistBtn.style.zIndex = '1000';
  wishlistBtn.style.backgroundColor = '#E25154';
  wishlistBtn.style.color = '#fff';
  wishlistBtn.style.display = 'flex';
  wishlistBtn.style.alignItems = 'center';
  wishlistBtn.style.justifyContent = 'center';
  wishlistBtn.style.border = 'none';
  wishlistBtn.style.gap = '5px';
  wishlistBtn.style.padding = '10px';
  wishlistBtn.style.cursor = 'pointer'

  const parentBtnForWishlist = document.querySelector('.footer-extra');
  if (parentBtnForWishlist) {
    parentBtnForWishlist.appendChild(wishlistBtn);
  } else {
    console.error('Parent element for wishlist button not found.');
    return;
  }
} else {
  console.log('Wishlist button already exists.');
}

 
  
  document.querySelector('.snize-wishlist-button').addEventListener('click', function() {
    renderModal();
  });
  

  document.querySelectorAll('.snize-product').forEach(function(product) {
    const productId = product.getAttribute('data-original-product-id');
    
    if (!product.querySelector('.add-to-local-storage')) {
      const button = document.createElement('button');
      button.classList.add('add-to-local-storage');
      
      const svgAdd = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="#000" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5996 20.325C12.3663 20.325 12.1289 20.2834 11.8876 20.2C11.6463 20.1167 11.4336 19.9834 11.2496 19.8L9.52461 18.225C7.75794 16.6084 6.16194 15.0044 4.73661 13.413C3.31128 11.8217 2.59894 10.0674 2.59961 8.15002C2.59961 6.58336 3.12461 5.27502 4.17461 4.22502C5.22461 3.17502 6.53294 2.65002 8.09961 2.65002C8.98294 2.65002 9.81628 2.83736 10.5996 3.21202C11.3829 3.58669 12.0496 4.09936 12.5996 4.75002C13.1496 4.10002 13.8163 3.58769 14.5996 3.21302C15.3829 2.83836 16.2163 2.65069 17.0996 2.65002C18.6663 2.65002 19.9746 3.17502 21.0246 4.22502C22.0746 5.27502 22.5996 6.58336 22.5996 8.15002C22.5996 10.0667 21.8913 11.825 20.4746 13.425C19.0579 15.025 17.4496 16.6334 15.6496 18.25L13.9496 19.8C13.7663 19.9834 13.5539 20.1167 13.3126 20.2C13.0713 20.2834 12.8336 20.325 12.5996 20.325ZM11.6496 6.75002C11.1663 6.06669 10.6496 5.54569 10.0996 5.18702C9.54961 4.82836 8.88294 4.64936 8.09961 4.65002C7.09961 4.65002 6.26628 4.98336 5.59961 5.65002C4.93294 6.31669 4.59961 7.15002 4.59961 8.15002C4.59961 9.01669 4.90794 9.93769 5.52461 10.913C6.14128 11.8884 6.87894 12.834 7.73761 13.75C8.59628 14.666 9.47961 15.5244 10.3876 16.325C11.2956 17.1257 12.0329 17.784 12.5996 18.3C13.1663 17.7834 13.9039 17.125 14.8126 16.325C15.7213 15.525 16.6046 14.6667 17.4626 13.75C18.3206 12.8334 19.0579 11.8877 19.6746 10.913C20.2913 9.93836 20.5996 9.01736 20.5996 8.15002C20.5996 7.15002 20.2663 6.31669 19.5996 5.65002C18.9329 4.98336 18.0996 4.65002 17.0996 4.65002C16.3163 4.65002 15.6496 4.82936 15.0996 5.18802C14.5496 5.54669 14.0329 6.06736 13.5496 6.75002C13.4329 6.91669 13.2913 7.04169 13.1246 7.12502C12.9579 7.20836 12.7829 7.25002 12.5996 7.25002C12.4163 7.25002 12.2413 7.20836 12.0746 7.12502C11.9079 7.04169 11.7663 6.91669 11.6496 6.75002Z" fill="#333333"/>
        </svg>
      `;
      
      const svgRemove = `
<svg width="25" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
  <path fill="#000000" d="M35.885 11.833c0-5.45-4.418-9.868-9.867-9.868-3.308 0-6.227 1.633-8.018 4.129-1.791-2.496-4.71-4.129-8.017-4.129-5.45 0-9.868 4.417-9.868 9.868 0 .772.098 1.52.266 2.241C1.751 22.587 11.216 31.568 18 34.034c6.783-2.466 16.249-11.447 17.617-19.959.17-.721.268-1.469.268-2.242z"/>
</svg>
      `;
      
      const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
      const productInWishlist = wishlist.some(item => item.id === productId);
      
      button.innerHTML = productInWishlist ? svgRemove : svgAdd;

      button.addEventListener('click', function(event) {
        event.stopPropagation();
        event.preventDefault();
        toggleProductInWishlist(productId, button, svgAdd, svgRemove); // Pass both SVGs for toggling
      });

      product.querySelector('.snize-item').appendChild(button);
    }
  });
}

function toggleProductInWishlist(productId, button, svgAdd, svgRemove) {
  const productElement = document.getElementById('snize-product-' + productId);
  
  const productName = productElement.querySelector('.snize-title').textContent.trim();
  const productPrice = productElement.querySelector('.snize-price').textContent.trim();
  const productLink = productElement.querySelector('.snize-view-link').getAttribute('href');
  const productImage = productElement.querySelector('.snize-thumbnail img').getAttribute('src');  // Corrected selector

  const productData = {
    id: productId,
    name: productName,
    price: productPrice,
    link: productLink,
    image: productImage
  };

  // console.log('Product Data:', productData);

  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  const productIndex = wishlist.findIndex(item => item.id === productId);

  if (productIndex === -1) {
    wishlist.push(productData);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Toggle the SVG to "Remove from Wishlist"
    button.innerHTML = svgRemove;
    Swal.fire({
      title: 'Added to Wishlist!',
      text: `${productName} has been successfully added to the wishlist.`,
      icon: 'success',
      confirmButtonText: 'OK'
    });


  } else {
    wishlist.splice(productIndex, 1);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    button.innerHTML = svgAdd;
    Swal.fire({
      title: 'Removed Wishlist!',
      text: `${productName} has been removed from wishlist.`,
      confirmButtonText: 'OK'
    });
  }
}


function triggerAddToCartById(productId) {
  const product = document.querySelector(`.snize-product[data-original-product-id="${productId}"]`);
  
  if (product) {
      const addToCartButton = product.querySelector('.snize-add-to-cart-button');
      
      if (addToCartButton) {
          addToCartButton.click();
          console.log('Product added to cart:', productId);
      } else {
          console.log('Add to Cart button not found for product:', productId);
      }
  } else {
      console.log('Product not found with ID:', productId);
  }
}



function renderModal() {
  // Check if the modal overlay already exists
  if (!document.querySelector('.modal-overlay')) {
    const body = document.querySelector('body');
    const modal = document.createElement('div');
    const modalContent = localStorage.getItem('wishlist');
    
    modal.innerHTML = `
      <div class="modal-overlay">
        <div class="modal-content">
          <h2>Collections Wishlist</h2>
          <ul class="wishlist-items">
            <button class="modal-close" id="closeModalBtn">&times;</button>
            ${JSON.parse(modalContent)?.map(item => `
              <li class='cards-of-wishlist' data-id="${item.id}">
                <div class="wishlist-item">
                  <img src="${item.image}" alt="${item.name}" class="wishlist-item-image">
                  <div class="wishlist-item-details">
                    <a href="${item.link}"
                    <h3 class="item_name">${item.name}</h3>
                    </a>
                    <button class="snize-add-to-cart-button" onclick="triggerAddToCartById('${item.id}')">Add to Cart</button>
                    <button class="snize-add-to-cart-button remove-from-wishlist" onclick="removeFromWishlist('${item.id}')">Remove</button>
                  </div>
                </div>
              </li>
              
            `).join('') || '<li>No items in wishlist.</li>'}
          </ul>
        </div>
      </div>
    `;

    modal.classList.add('modal');
    body.appendChild(modal);

    const closeModalBtn = document.getElementById('closeModalBtn');
    closeModalBtn.addEventListener('click', function() {
      modal.remove();
    });


    const  modalOverlay = document.querySelector('.modal-overlay');
    modalOverlay.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      modal.remove();
    });
    

    const modalContentab = document.querySelector('.modal-content');
    modalContentab.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    const style2 = document.createElement('style');
    style2.innerHTML = `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        animation: fadeIn 0.3s ease-in-out;
      }


      .snize-add-to-cart-button {
        cursor: pointer;
        background-color: #F04F36;
        color: white;
        border: none;
        padding: 10px 20px;
        width: 200px;
        border-radius: 5px;
        font-size: 14px;
        transition: background-color 0.3s ease;
      }

      .snize-add-to-cart-button:hover {
        background-color:rgb(245, 131, 113);
      }

      .modal-content {
        position: relative !important;
      }

      .item_name {
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0;
        color: #333;
      }

      .remove-from-wishlist{
        background: #675656;
      }

      .cards-of-wishlist {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 15px;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
      }

      .wishlist-item {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .wishlist-item-image {
          width: 107px;
          height: 137px;
          object-fit: cover;
          border-radius: 8px;
          margin-right: 15px;
          box-shadow: -9px -10px 15px 4px rgba(0, 0, 0, 0.1);
      }

      .wishlist-item-details {
        display: flex;
        gap: 20px;
        flex-direction: column;
      }

      .modal-content {
        background: white;
        padding: 25px;
        border-radius: 8px;
        width: 400px;
        max-width: 600px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        animation: scaleUp 0.3s ease-in-out;
        height: 500px;
        overflow: auto;
      }

      @media screen and (max-width: 767px){       
        .snize-wishlist-button{
            bottom: 90px;
        }
        
      }


      .modal-close {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 1.8rem;
        cursor: pointer;
        color: #333;
        transition: color 0.3s ease;
      }

      .modal-close:hover {
        color: #ff0000;
      }

      .wishlist-items {
        list-style-type: none;
        padding: 0;
        margin-top: 20px;
      }

      .wishlist-items li {
        margin-bottom: 15px;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes scaleUp {
        from {
          transform: scale(0.9);
        }
        to {
          transform: scale(1);
        }
      }
    `;

    document.head.appendChild(style2);
  }
}

// Function to remove item from wishlist (UI & localStorage)
function removeFromWishlist(productId) {
  // Get current wishlist from localStorage
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Remove the item from wishlist array
  wishlist = wishlist.filter(item => item.id !== productId);

  // Update localStorage with the new wishlist
  localStorage.setItem('wishlist', JSON.stringify(wishlist));

  // Remove the item from the UI
  const itemToRemove = document.querySelector(`.cards-of-wishlist[data-id="${productId}"]`);
  if (itemToRemove) {
    itemToRemove.remove();
  }

  window.location.reload()

}

// Function to trigger Add to Cart by product ID
function triggerAddToCartById(productId) {
  const product = document.querySelector(`.snize-product[data-original-product-id="${productId}"]`);
  
  if (product) {
    const addToCartButton = product.querySelector('.snize-add-to-cart-button');
    
    if (addToCartButton) {
      addToCartButton.click();
    } else {
      console.log('Add to Cart button not found for product:', productId);
    }
  } else {
    console.log('Product not found with ID:', productId);
  }
}





// renderModal();




const style3 = document.createElement('style');
style3.innerHTML = `
  .add-to-local-storage {
    position: absolute !important;
    top: 4px !important;
    right: 4px !important;
    background: none;
    border: none;
    cursor: pointer;
    display: block;
}

  .add-to-local-storage svg {
    fill: #007bff;
    width: 24px;
    height: 24px;
    transition: fill 0.3s;
  }

  


  

  .add-to-local-storage:hover svg {
    fill: #0056b3;
  }

  .add-to-local-storage:focus {
    outline: none;
  }
`;

document.head.appendChild(style3);


setTimeout(() => {
  addWishlistButton();
}, 2500);



